export default __webpack_public_path__ + "static/media/Horn.294338b6.svg";